import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";

// import warn from "../../../../constants/toast";
import MaterialUI from "../../../../material-UI";
import axiosLead from "../../../../services/lead";
import handleApiError from "../../../../utils/handleApiError";
import * as Styles from "../../styles";

interface Props {
  idLead?: string | any;
  idLeadCorretor: string | undefined;
  onClose: Function;
  open: boolean;
  hotRefreshFunc: Function;
}

const DesqualifyForm: React.FC<Props> = ({
  idLead,
  idLeadCorretor,
  onClose,
  open,
  hotRefreshFunc,
}) => {
  const [corretores, setCorretores] = useState([]);
  const [value, setValue] = useState({
    idUsuario: "",
    nome: "",
    idCorretor: "",
  });
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    requestCorretores();
  }, []);

  const requestCorretores = async () => {
    try {
      const response = await axiosLead.GetCorretores();
      setCorretores(response.data.data);
    } catch (error: any) {
      console.log(
        error?.response?.data?.notifications
          ? error?.response?.data?.notifications?.map(
              (item: any) => `${item.message}\n`
            )
          : "Erro ao listar corretores"
      );
      // warn.wargingError(
      //   `${
      //     error?.response?.data?.notifications?.map(
      //       (item: any) => `${item.message}\n`
      //     ) || "Erro ao listar corretores"
      //   }`
      // );
    }
  };

  const sharedLead = async () => {
    try {
      if (value.nome === "") {
        toast.error("Selecione um corretor.");
        return;
      }
      setLoading(true);
      await axiosLead.sharedLead({
        leads: [
          {
            idLead,
            idLeadCorretor,
          },
        ],
        idUsuarioDestinoLead: value.idUsuario,
        idCorretorDestinoLead: value.idCorretor,
        permissaoGravacao: true,
      });
      toast.success("Compartilhamento feito com sucesso.");
      onClose(!open);
      hotRefreshFunc();
    } catch (error: any) {
      handleApiError(error);
    }
    setLoading(false);
  };

  return (
    <>
      <Styles.TransferComponent>
        <Styles.Autocomplete
          id="combo-box-demo"
          options={corretores}
          renderInput={(params: any) => (
            <>
              <Styles.LabelText>Corretor de destino</Styles.LabelText>
              <Styles.TextField
                size="small"
                InputLabelProps={{ shrink: false }}
                variant="outlined"
                {...params}
                label="Corretor de destino"
              />
            </>
          )}
          getOptionLabel={(option: any) => option.nome || ""}
          onChange={(event, newValue: any) => {
            setValue(newValue);
          }}
        />
      </Styles.TransferComponent>
      <Styles.Footer>
        <Styles.FooterDialog>
          <Styles.Button variant="outlined" onClick={() => onClose(!open)}>
            Cancelar
          </Styles.Button>
          <Styles.Button
            className="transfer-btn"
            color="secondary"
            variant="contained"
            onClick={sharedLead}
          >
            {loading ? <MaterialUI.CircularProgress /> : "Compartilhar"}
          </Styles.Button>
        </Styles.FooterDialog>
      </Styles.Footer>
    </>
  );
};

export default DesqualifyForm;
